(function(){
var dom = require('./dom'), URL=dom.URL, doc=dom.doc, on_load=dom.on_load;
var debug = require('./debug'), try_reporter=debug.try_reporter;
var Login = require('./login');

on_load(try_reporter(function () {
    var lib = require('./lib'), merge=lib.merge;
    window.the_game = require('./solitaire').start(URL.param.variant || URL.path.replace(/^\/|#.*$/g, ""),
                                                 merge(require('./piles-ui.browser'),
                                                       { activate: doc.id("activate") }),
                                                 URL.param.game);
    if (URL.param.replay) window.the_game.replay(URL.param.replay, false)
    else window.the_game.restore_game(URL.param.game);
}, "on_load", { path:URL.path, game:URL.param.game, replay:URL.param.replay }));

doc.id('keyboard-play-toggle').onclick = function() {
    doc.id('instructions-keyboard').style.display = doc.id('instructions-keyboard').style.display == 'none' ? 'block' : 'none';
    return false;
};
doc.id('mouse-play-toggle').onclick = function() {
    doc.id('instructions-mouse').style.display = doc.id('instructions-mouse').style.display == 'none' ? 'block' : 'none';
    return false;
};
doc.id('super-moves-toggle').onclick = function() {
    doc.id('instructions-super-moves').style.display = doc.id('instructions-super-moves').style.display == 'none' ? 'block' : 'none';
    return false;
};
(doc.id('instructions-run-based-scoring-toggle') ?? {}).onclick = function() {
    doc.id('instructions-run-based-scoring').style.display = doc.id('instructions-run-based-scoring').style.display == 'none' ? 'block' : 'none';
    return false;
};
})()(function(){
var dom = require('./dom'), URL=dom.URL, doc=dom.doc, on_load=dom.on_load;
var debug = require('./debug'), try_reporter=debug.try_reporter;
var Login = require('./login');

on_load(try_reporter(function () {
    var lib = require('./lib'), merge=lib.merge;
    window.the_game = require('./solitaire').start(URL.param.variant || URL.path.replace(/^\/|#.*$/g, ""),
                                                 merge(require('./piles-ui.browser'),
                                                       { activate: doc.id("activate") }),
                                                 URL.param.game);
    if (URL.param.replay) window.the_game.replay(URL.param.replay, false)
    else window.the_game.restore_game(URL.param.game);
}, "on_load", { path:URL.path, game:URL.param.game, replay:URL.param.replay }));

doc.id('keyboard-play-toggle').onclick = function() {
    doc.id('instructions-keyboard').style.display = doc.id('instructions-keyboard').style.display == 'none' ? 'block' : 'none';
    return false;
};
doc.id('mouse-play-toggle').onclick = function() {
    doc.id('instructions-mouse').style.display = doc.id('instructions-mouse').style.display == 'none' ? 'block' : 'none';
    return false;
};
doc.id('super-moves-toggle').onclick = function() {
    doc.id('instructions-super-moves').style.display = doc.id('instructions-super-moves').style.display == 'none' ? 'block' : 'none';
    return false;
};
(doc.id('instructions-run-based-scoring-toggle') ?? {}).onclick = function() {
    doc.id('instructions-run-based-scoring').style.display = doc.id('instructions-run-based-scoring').style.display == 'none' ? 'block' : 'none';
    return false;
};
})()